/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AddFeaturedStreamBody,
  ApiError,
  StreamingSettings,
  StreamingSettingsResponse,
  UpdateStreamingSettingsBody,
} from '../models/index';
import {
    AddFeaturedStreamBodyFromJSON,
    AddFeaturedStreamBodyToJSON,
    ApiErrorFromJSON,
    ApiErrorToJSON,
    StreamingSettingsFromJSON,
    StreamingSettingsToJSON,
    StreamingSettingsResponseFromJSON,
    StreamingSettingsResponseToJSON,
    UpdateStreamingSettingsBodyFromJSON,
    UpdateStreamingSettingsBodyToJSON,
} from '../models/index';

export interface CreateCompetitionsCompetitionIdStreamingFeaturedRequest {
    competitionId: string;
    addFeaturedStreamBody: AddFeaturedStreamBody;
}

export interface DeleteCompetitionsCompetitionIdStreamingFeaturedStreamIdRequest {
    competitionId: string;
    streamId: string;
}

export interface GetCompetitionsCompetitionIdStreamingRequest {
    competitionId: string;
}

export interface UpdateCompetitionsCompetitionIdStreamingRequest {
    competitionId: string;
    updateStreamingSettingsBody: UpdateStreamingSettingsBody;
}

/**
 * CompetitionStreamingApi - interface
 * 
 * @export
 * @interface CompetitionStreamingApiInterface
 */
export interface CompetitionStreamingApiInterface {
    /**
     * Add a featured stream to a competition
     * @param {string} competitionId 
     * @param {AddFeaturedStreamBody} addFeaturedStreamBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompetitionStreamingApiInterface
     */
    createCompetitionsCompetitionIdStreamingFeaturedRaw(requestParameters: CreateCompetitionsCompetitionIdStreamingFeaturedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StreamingSettings>>;

    /**
     * Add a featured stream to a competition
     */
    createCompetitionsCompetitionIdStreamingFeatured(requestParameters: CreateCompetitionsCompetitionIdStreamingFeaturedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StreamingSettings>;

    /**
     * Remove a featured stream from a competition
     * @param {string} competitionId 
     * @param {string} streamId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompetitionStreamingApiInterface
     */
    deleteCompetitionsCompetitionIdStreamingFeaturedStreamIdRaw(requestParameters: DeleteCompetitionsCompetitionIdStreamingFeaturedStreamIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StreamingSettings>>;

    /**
     * Remove a featured stream from a competition
     */
    deleteCompetitionsCompetitionIdStreamingFeaturedStreamId(requestParameters: DeleteCompetitionsCompetitionIdStreamingFeaturedStreamIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StreamingSettings>;

    /**
     * Get streaming settings for a competition
     * @param {string} competitionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompetitionStreamingApiInterface
     */
    getCompetitionsCompetitionIdStreamingRaw(requestParameters: GetCompetitionsCompetitionIdStreamingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StreamingSettingsResponse>>;

    /**
     * Get streaming settings for a competition
     */
    getCompetitionsCompetitionIdStreaming(requestParameters: GetCompetitionsCompetitionIdStreamingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StreamingSettingsResponse>;

    /**
     * Update streaming settings for a competition
     * @param {string} competitionId 
     * @param {UpdateStreamingSettingsBody} updateStreamingSettingsBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompetitionStreamingApiInterface
     */
    updateCompetitionsCompetitionIdStreamingRaw(requestParameters: UpdateCompetitionsCompetitionIdStreamingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StreamingSettings>>;

    /**
     * Update streaming settings for a competition
     */
    updateCompetitionsCompetitionIdStreaming(requestParameters: UpdateCompetitionsCompetitionIdStreamingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StreamingSettings>;

}

/**
 * 
 */
export class CompetitionStreamingApi extends runtime.BaseAPI implements CompetitionStreamingApiInterface {

    /**
     * Add a featured stream to a competition
     */
    async createCompetitionsCompetitionIdStreamingFeaturedRaw(requestParameters: CreateCompetitionsCompetitionIdStreamingFeaturedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StreamingSettings>> {
        if (requestParameters['competitionId'] == null) {
            throw new runtime.RequiredError(
                'competitionId',
                'Required parameter "competitionId" was null or undefined when calling createCompetitionsCompetitionIdStreamingFeatured().'
            );
        }

        if (requestParameters['addFeaturedStreamBody'] == null) {
            throw new runtime.RequiredError(
                'addFeaturedStreamBody',
                'Required parameter "addFeaturedStreamBody" was null or undefined when calling createCompetitionsCompetitionIdStreamingFeatured().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/competitions/{competitionId}/streaming/featured`;
        urlPath = urlPath.replace(`{${"competitionId"}}`, encodeURIComponent(String(requestParameters['competitionId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddFeaturedStreamBodyToJSON(requestParameters['addFeaturedStreamBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StreamingSettingsFromJSON(jsonValue));
    }

    /**
     * Add a featured stream to a competition
     */
    async createCompetitionsCompetitionIdStreamingFeatured(requestParameters: CreateCompetitionsCompetitionIdStreamingFeaturedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StreamingSettings> {
        const response = await this.createCompetitionsCompetitionIdStreamingFeaturedRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Remove a featured stream from a competition
     */
    async deleteCompetitionsCompetitionIdStreamingFeaturedStreamIdRaw(requestParameters: DeleteCompetitionsCompetitionIdStreamingFeaturedStreamIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StreamingSettings>> {
        if (requestParameters['competitionId'] == null) {
            throw new runtime.RequiredError(
                'competitionId',
                'Required parameter "competitionId" was null or undefined when calling deleteCompetitionsCompetitionIdStreamingFeaturedStreamId().'
            );
        }

        if (requestParameters['streamId'] == null) {
            throw new runtime.RequiredError(
                'streamId',
                'Required parameter "streamId" was null or undefined when calling deleteCompetitionsCompetitionIdStreamingFeaturedStreamId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/competitions/{competitionId}/streaming/featured/{streamId}`;
        urlPath = urlPath.replace(`{${"competitionId"}}`, encodeURIComponent(String(requestParameters['competitionId'])));
        urlPath = urlPath.replace(`{${"streamId"}}`, encodeURIComponent(String(requestParameters['streamId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StreamingSettingsFromJSON(jsonValue));
    }

    /**
     * Remove a featured stream from a competition
     */
    async deleteCompetitionsCompetitionIdStreamingFeaturedStreamId(requestParameters: DeleteCompetitionsCompetitionIdStreamingFeaturedStreamIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StreamingSettings> {
        const response = await this.deleteCompetitionsCompetitionIdStreamingFeaturedStreamIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get streaming settings for a competition
     */
    async getCompetitionsCompetitionIdStreamingRaw(requestParameters: GetCompetitionsCompetitionIdStreamingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StreamingSettingsResponse>> {
        if (requestParameters['competitionId'] == null) {
            throw new runtime.RequiredError(
                'competitionId',
                'Required parameter "competitionId" was null or undefined when calling getCompetitionsCompetitionIdStreaming().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/competitions/{competitionId}/streaming`;
        urlPath = urlPath.replace(`{${"competitionId"}}`, encodeURIComponent(String(requestParameters['competitionId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StreamingSettingsResponseFromJSON(jsonValue));
    }

    /**
     * Get streaming settings for a competition
     */
    async getCompetitionsCompetitionIdStreaming(requestParameters: GetCompetitionsCompetitionIdStreamingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StreamingSettingsResponse> {
        const response = await this.getCompetitionsCompetitionIdStreamingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update streaming settings for a competition
     */
    async updateCompetitionsCompetitionIdStreamingRaw(requestParameters: UpdateCompetitionsCompetitionIdStreamingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StreamingSettings>> {
        if (requestParameters['competitionId'] == null) {
            throw new runtime.RequiredError(
                'competitionId',
                'Required parameter "competitionId" was null or undefined when calling updateCompetitionsCompetitionIdStreaming().'
            );
        }

        if (requestParameters['updateStreamingSettingsBody'] == null) {
            throw new runtime.RequiredError(
                'updateStreamingSettingsBody',
                'Required parameter "updateStreamingSettingsBody" was null or undefined when calling updateCompetitionsCompetitionIdStreaming().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/competitions/{competitionId}/streaming`;
        urlPath = urlPath.replace(`{${"competitionId"}}`, encodeURIComponent(String(requestParameters['competitionId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateStreamingSettingsBodyToJSON(requestParameters['updateStreamingSettingsBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StreamingSettingsFromJSON(jsonValue));
    }

    /**
     * Update streaming settings for a competition
     */
    async updateCompetitionsCompetitionIdStreaming(requestParameters: UpdateCompetitionsCompetitionIdStreamingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StreamingSettings> {
        const response = await this.updateCompetitionsCompetitionIdStreamingRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
